import { Modal } from "@maysoft/common-component-react"
import { useEffect, useState } from "react"
import TelegramConfigForm from "../container/telegramConfig"
import Strings from "constants/strings"
import { SettingProps } from "./simpleConfigModal"
import BasicInfoSection from "../container/baseInfo"

type TelegramConfig = {
    BotToken: string
    BotUserName: string
    HostAddress: string
    DefaultChatId: string
}

const defaultValue: TelegramConfig = {
    BotToken: "",
    BotUserName: "",
    HostAddress: "",
    DefaultChatId: ""
}

const TelegramConfigPopup = ({
    serviceName,
    tenantName,
    visibled,
    value,
    onClose,
    onSubmit
}: SettingProps) => {

    const [config, setConfig] =
        useState<TelegramConfig>(defaultValue)

    useEffect(() => {
        try {
            setConfig(JSON.parse(value))
        } catch {
            setConfig(defaultValue)
        }
    }, [value])

    return (
        <Modal
            visible={visibled}
            maxWidth="md"
            fullWidth
            title="Telegram Bot Configuration"
            hasActionButton
            buttonAction={Strings.Common.SAVE}
            onClose={onClose}
            onAction={() =>
                onSubmit(JSON.stringify(config))
            }
        >
            <BasicInfoSection
                title={Strings.SETTING.BASIC}
                items={[
                    {
                        label: Strings.SETTING.SERVICE,
                        value: serviceName
                    },
                    {
                        label: Strings.SETTING.TENANT,
                        value: tenantName
                    }
                ]}
            />
            <TelegramConfigForm
                value={config}
                onChange={setConfig}
            />
        </Modal>
    )
}

export default TelegramConfigPopup